import SmoothScroll from 'smooth-scroll';

export function smooth() {
  const scroll = new SmoothScroll('a[href*="#"]', {
    header: '.l-header',
    speed: 300,
    speedAsDuration: true,
    updateURL: false,
  });

 document.addEventListener('scrollStart', closeHeaderNav, false);
}

function closeHeaderNav() {
  let trigger = document.getElementById('js-navTrigger');
  let target = document.getElementById('js-navTarget');
  trigger.classList.remove('is-show');
  target.classList.remove('is-show');

}